import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { THREE_COLUMN_MONITORING_LAYOUT } from './ThreeColumnMonitoring';

export const THREE_COLUMN_MONITORING_LAYOUT_SPEC: LayoutSpec = {
  templateId: 'threeColumn',
  label: 'Orders / Trades / Execution Reports',
  id: 'threeColumn',
  dockViewLayout: THREE_COLUMN_MONITORING_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
